import {
  FilterValueType,
  SuggestionSourceType,
  type FilterDefinition,
  type FilterSuggestionConfig,
  type StructuredSearchSchema,
  getFilterDefinitionByKey,
} from "./structured-search-schema";
import { isNestedFilterType } from "./filter-value-type-behavior";

export const getFilterSuggestionConfig = (
  definition: FilterDefinition | undefined,
): FilterSuggestionConfig | undefined => definition?.suggestions;

export const filterUsesNestedSuggestions = (definition: FilterDefinition): boolean =>
  definition.suggestions?.source === SuggestionSourceType.Nested;

export const filterUsesAggregationSuggestions = (definition: FilterDefinition): boolean =>
  definition.suggestions?.source === SuggestionSourceType.Aggregation ||
  filterUsesNestedSuggestions(definition);

export const filterUsesRegistrySuggestions = (definition: FilterDefinition): boolean => {
  const source = definition.suggestions?.source;
  return (
    source === SuggestionSourceType.PromptRegistry ||
    source === SuggestionSourceType.WorkflowRegistry
  );
};

export const getAggregationSuggestionField = (definition: FilterDefinition): string => {
  const { suggestions } = definition;
  if (suggestions?.source === SuggestionSourceType.Aggregation && suggestions.field) {
    return suggestions.field;
  }

  return definition.key;
};

export const schemaHasAggregationSuggestions = (schema: StructuredSearchSchema): boolean =>
  schema.filters.some(filterUsesAggregationSuggestions);

export const schemaHasAsyncSuggestions = (schema: StructuredSearchSchema): boolean =>
  schema.filters.some(
    filter =>
      filterUsesAggregationSuggestions(filter) ||
      filterUsesRegistrySuggestions(filter) ||
      filterUsesNestedSuggestions(filter),
  );

export const usesDropdownValueStep = (filter: FilterDefinition): boolean =>
  isNestedFilterType(filter.type) ||
  filter.type === FilterValueType.Prompt ||
  filter.type === FilterValueType.Enum ||
  filter.suggestions?.source === SuggestionSourceType.Aggregation ||
  filter.suggestions?.source === SuggestionSourceType.Static ||
  filterUsesRegistrySuggestions(filter);

export const isHydratedIdFilter = (
  schema: StructuredSearchSchema,
  field: string | undefined,
): boolean => {
  const definition = getFilterDefinitionByKey(schema, field);
  return definition ? filterUsesRegistrySuggestions(definition) : false;
};
